/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const SelectBoxIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Select Box',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M29.2 2H6.8A4.8 4.8 0 0 0 2 6.8v22.4A4.8 4.8 0 0 0 6.8 34h22.4a4.8 4.8 0 0 0 4.8-4.8V6.8A4.8 4.8 0 0 0 29.2 2Zm-.355 10.377L14.566 26.655a.8.8 0 0 1-1.131 0l-6.28-6.278a.8.8 0 0 1 0-1.131l2.491-2.491a.8.8 0 0 1 1.131 0L14 19.98 25.223 8.755a.8.8 0 0 1 1.131 0l2.491 2.491a.8.8 0 0 1 0 1.131Z"
    />
  </svg>`;
};
